module.exports = __webpack_public_path__ + "img/0x0d9319565be7f53CeFE84Ad201Be3f40feAE2740.a9a7639c.png";